import React, { useRef, useEffect } from "react";

const FrequencyVisualizer = ({ frequencies, isActive }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const width = canvas.width;
    const height = canvas.height;

    // Clear canvas
    ctx.fillStyle = "hsl(220, 15%, 8%)";
    ctx.fillRect(0, 0, width, height);

    if (!isActive) {
      // Draw inactive state
      ctx.fillStyle = "hsl(220, 15%, 25%)";
      ctx.font = "16px monospace";
      ctx.textAlign = "center";
      ctx.fillText(
        'Click "Start Recording" to begin analysis',
        width / 2,
        height / 2
      );
      return;
    }

    // Draw frequency bars
    const barCount = Math.min(frequencies.length, 128);
    const barWidth = width / barCount;

    for (let i = 0; i < barCount; i++) {
      const value = frequencies[i];
      const barHeight = (value / 255) * height * 0.8;

      // Create gradient based on frequency range
      const gradient = ctx.createLinearGradient(
        0,
        height,
        0,
        height - barHeight
      );

      if (i < barCount * 0.3) {
        // Low frequencies - pink/red
        gradient.addColorStop(0, "hsl(330, 80%, 60%)");
        gradient.addColorStop(1, "hsl(330, 80%, 80%)");
      } else if (i < barCount * 0.7) {
        // Mid frequencies - yellow/orange
        gradient.addColorStop(0, "hsl(60, 100%, 60%)");
        gradient.addColorStop(1, "hsl(60, 100%, 80%)");
      } else {
        // High frequencies - cyan/blue
        gradient.addColorStop(0, "hsl(180, 100%, 60%)");
        gradient.addColorStop(1, "hsl(180, 100%, 80%)");
      }

      ctx.fillStyle = gradient;
      ctx.fillRect(i * barWidth, height - barHeight, barWidth - 1, barHeight);

      // Add glow effect for active bars
      if (value > 50) {
        ctx.shadowColor = gradient.addColorStop
          ? "hsl(180, 100%, 70%)"
          : "cyan";
        ctx.shadowBlur = 10;
        ctx.fillRect(i * barWidth, height - barHeight, barWidth - 1, barHeight);
        ctx.shadowBlur = 0;
      }
    }

    // Draw waveform overlay
    ctx.strokeStyle = "hsl(180, 100%, 70%)";
    ctx.lineWidth = 2;
    ctx.beginPath();

    for (let i = 0; i < barCount; i++) {
      const x = (i / barCount) * width;
      const y = height - (frequencies[i] / 255) * height * 0.8;

      if (i === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
    }

    ctx.stroke();
  }, [frequencies, isActive]);

  return (
    <div className="waveform-container">
      <canvas
        ref={canvasRef}
        width={400}
        height={180}
        className="w-full h-[180px] rounded-lg"
        style={{ background: "hsl(220, 15%, 8%)" }}
      />

      {/* Frequency Scale */}
      <div className="flex justify-between mt-2 text-xs text-muted-foreground font-mono">
        <span>0 Hz</span>
        <span>Low</span>
        <span>Mid</span>
        <span>High</span>
        <span>24 kHz</span>
      </div>
    </div>
  );
};

export default FrequencyVisualizer;
